import { createFileRoute, redirect } from "@tanstack/react-router"
import { IconOfficeFill18 } from "nucleo-ui-fill-18"

import { EmptyState } from "@/components/common/empty-state"
import { SignOutButton } from "@/features/auth/components/sign-out-button"

export const Route = createFileRoute("/_authenticated/organisations/none/")({
  beforeLoad: ({ context }) => {
    const { organisations, portal } = context.session

    if (organisations.length > 0 || portal.length > 0) {
      throw redirect({ to: "/" })
    }
  },
  component: NoOrganisationPage,
})

function NoOrganisationPage() {
  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <EmptyState
        icon={<IconOfficeFill18 />}
        title="No organisation"
        description="Your account is not a member of any organisation yet. Ask an administrator to invite you, then sign in again."
        actions={<SignOutButton />}
      />
    </div>
  )
}
